/** Soft Release / Super Soft Release: one row per released lot, the SR Status tabs. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { SOFT_RELEASE_KINDS, SOFT_RELEASE_TABS } from "@nexseed/shared";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { SoftReleaseListPage } from "@/features/quality/components/soft-release/soft-release-list-page";

const search = z.object({
  tab: z.enum(SOFT_RELEASE_TABS).default("active"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  // Ended, Failed and Cancelled's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/releases/$kind/")({
  params: {
    parse: ({ kind }) => {
      if (!(SOFT_RELEASE_KINDS as readonly string[]).includes(kind))
        throw notFound();
      return { kind: kind as (typeof SOFT_RELEASE_KINDS)[number] };
    },
    stringify: (p) => p,
  },
  validateSearch: search,
  beforeLoad: () => {
    const can = useAuth.getState().can;
    if (
      !can("qc.view") &&
      !can("qc.soft_release") &&
      !can("qc.super_soft_release")
    )
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useParams();
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SoftReleaseListPage
      kind={kind}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
